/*
*查询退改政策
*/
const __request = require(`./__request/__request_contentType_json`)
const request = (data) => {
  let pParameter = {
    method: 'post',
    urlSuffix: '/consumer/t-tp-refund-change-policy/get',
    data: data
  }
  return __request(pParameter)
}
export default request